import React from 'react';
import { AccentCardContainer, Chip } from './AccentCard.style';
import { type AccentImage } from '../../../Subsection';

export const AccentCard = ({ content }: { content: AccentImage }) => {
  const { image, name } = content;
  return (
    <AccentCardContainer>
      {image.desktop}
      {name && <Chip>{name}</Chip>}
    </AccentCardContainer>
  );
};
